import React from 'react';
import { getSignInsForDate } from '../utils/date-helpers-consolidated';
import {EmployeeCard} from './EmployeeCard';
import { COLOR_PALETTE } from '../utils/constants';

interface EmployeeOverlayProps {
  date: Date;
  employees: any[]; // Replace with more specific type if available
  selectedTab: string;
  onTabClick: (tab: string) => void;
  onClose: () => void;
  viewUserProfile: (employee: any) => void; // Replace with more specific type if available
}

const EmployeeOverlay = ({ date, employees, selectedTab, onTabClick, onClose, viewUserProfile }: EmployeeOverlayProps) => {
    // Add search functionality here
    const [daySearch, setDaySearch] = React.useState('');
    const allSignIns = getSignInsForDate(employees, date);
    
    // Filter by search
    const filtered = daySearch.trim() === ''
      ? allSignIns
      : allSignIns.filter(e => e.name.toLowerCase().includes(daySearch.toLowerCase()));

    // counts
    const allCount = allSignIns.length;
    const magniCount = allSignIns.filter(e=>e.type==='Magni').length;
    const guestCount = allSignIns.filter(e=>e.type==='Guest').length;
    const finalList = selectedTab==='All' ? filtered : filtered.filter(e=>e.type===selectedTab);

    const dateString = date.toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'});
    


    return (
      <div className={`overlay-apple ${date?'active':''}`} onClick={onClose}>
        <div className="popup-apple" onClick={e=>e.stopPropagation()}>
          <div className="popup-header-apple">
            <button className="back-button-apple" onClick={onClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="currentColor"/>
              </svg>
            </button>
            <h2 className="popup-title-apple">{dateString}</h2>
            <div style={{ width: 24 }}></div> {/* Empty div for centering */}
          </div>
          
          <div className="tabs-apple">
            <div 
              className={`tab-apple ${selectedTab==='All'?'active':''}`} 
              onClick={()=>onTabClick('All')}
            >
              All <span className="tab-count-apple">{allCount}</span>
            </div>
            <div 
              className={`tab-apple ${selectedTab==='Magni'?'active':''}`} 
              onClick={()=>onTabClick('Magni')}
            >
              Magni <span className="tab-count-apple">{magniCount}</span>
            </div>
            <div 
              className={`tab-apple ${selectedTab==='Guest'?'active':''}`} 
              onClick={()=>onTabClick('Guest')}
            >
              Guest <span className="tab-count-apple">{guestCount}</span>
            </div>
          </div>
          
          <div className="employee-search-apple">
            <div className="search-icon-apple">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="currentColor"/>
              </svg>
            </div>
            <input
              className="search-input-apple"
              type="text"
              placeholder="Search by name..."
              value={daySearch}
              onChange={e=>setDaySearch(e.target.value)}
            />
          </div>
          
          <div className="employee-list-apple">
            {finalList.length === 0 ? (
              <div className="no-results-apple">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor"/>
                </svg>
                <p>No matching employees found</p>
              </div>
            ) : (
              finalList.map((emp, i) => (
                <EmployeeCard
                  key={i}
                  employee={emp}
                  colorIndex={i % COLOR_PALETTE.length}
                  date={date}
                  viewUserProfile={viewUserProfile}
                />
              ))
            )}
          </div>
        </div>
      </div>
    );
  };

  export default EmployeeOverlay;